// extracted by mini-css-extract-plugin
export default {"content":"Buy_content__AZSpB","cards":"Buy_cards__vM7qL","card":"Buy_card__o51pM"};